import { LoginAPI } from '@/api'
import { useUserContext } from '@/context'

import { useAPIMutation } from '../useAPI'

export function useRefresh() {
  const { refreshToken, logoutUser } = useUserContext()

  const mutation = useAPIMutation<LoginAPI.REFRESH.Body, LoginAPI.REFRESH.Response>(LoginAPI.refresh(), {
    onSuccess: ({ data }) => {
      document.cookie = `token=${data.token};path=/`
      refreshToken(data?.token)
    },
    onError: () => {
      logoutUser()
    },
  })

  return { ...mutation }
}
